// extracted by mini-css-extract-plugin
export default {"parlayBetBadge":"R6_POMLMkW5AfJjcaUTQ","badgeA":"x6qE8c4c03LGcGACJ8OJ","common_bganimation":"he_YECcPYkY6lBg_6EEL"};